import { useQuery } from '@tanstack/react-query';

import { getMailingSummary, type MailingSummary } from '@enterprise/api';
import { ensureError, isDefined } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { useApplicationStore } from '@hooks/application/application-store.hook';
import { nthQueryKeys } from '@components/nth-calculator/common/nth-query-keys';

import type { UseGetMailingSummaryResult } from './types/get-mailing-summary.type';

export const useGetMailingSummary = (mailingId?: number): UseGetMailingSummaryResult => {
  const enterpriseApi = useApplicationStore(({ enterpriseApi }) => {
    return enterpriseApi;
  });

  return useQuery({
    enabled: isDefined(mailingId),
    initialData: { success: false } as OperationResultWithData<MailingSummary[]>,
    initialDataUpdatedAt: 0,
    queryFn: async () => {
      try {
        return await getMailingSummary(enterpriseApi, { mailingId: mailingId ?? 0 });
      } catch (e) {
        const error = ensureError(e);

        console.error(error);

        return { success: false } as OperationResultWithData<MailingSummary[]>;
      }
    },
    queryKey: nthQueryKeys.mailingSummary(mailingId ?? 0),
    retry: true,
    select: (result): MailingSummary[] => {
      if (!result.success || !result.data) {
        return [];
      }

      return result.data;
    },
  });
};
